import { ApplicationRef, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { TranslateService } from '@ngx-translate/core'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import { I18nService } from '../i18n.service'
import {
  FetchAvaliableLanguagesFailure,
  FetchAvaliableLanguagesRequest,
  FetchAvaliableLanguagesSuccess,
  FetchDefaultTranslationsFailure,
  FetchDefaultTranslationsRequest,
  FetchDefaultTranslationsSuccess,
  FetchTranslationsListRequest,
  FetchTranslationsListSuccess,
  UpdateTranslationManualy,
  UpdateTranslationManualyFailure,
  UpdateTranslationManualySuccessfully,
} from './i18n.actions'
import * as i18nTypes from './i18n.types'

@Injectable()
export class I18nEffectsService {
  constructor(
    private actions: Actions,
    private i18nService: I18nService,
    private translateService: TranslateService,
    private appRef: ApplicationRef,
  ) {}

  FetchAvaliableLanguages$ = createEffect(() =>
    this.actions.pipe(
      ofType(i18nTypes.FETCH_AVALIABLE_LANGUAGES_REQUEST),
      switchMap((action: FetchAvaliableLanguagesRequest) => {
        return this.i18nService.fetchAvaliableLangList().pipe(
          map((result) => {
            return new FetchAvaliableLanguagesSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchAvaliableLanguagesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchDefaultTranslations$ = createEffect(() =>
    this.actions.pipe(
      ofType(i18nTypes.FETCH_DEFAULT_TRANSLATIONS_REQUEST),
      switchMap((action: FetchDefaultTranslationsRequest) => {
        return this.i18nService.fetchDefaultTranslations().pipe(
          map((translations) => {
            return new FetchDefaultTranslationsSuccess(translations)
          }),
          catchError((err, caught) => {
            return of(new FetchDefaultTranslationsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchTranslationsList$ = createEffect(() =>
    this.actions.pipe(
      ofType(i18nTypes.FETCH_TRANSLATIONS_LIST_REQUEST),
      switchMap((action: FetchTranslationsListRequest) => {
        return this.i18nService
          .fetchTranslationsList(action.queryParams, action.iso2code)
          .pipe(
            map((result) => {
              return new FetchTranslationsListSuccess(
                result.data.results,
                result.data.totalCount,
                result.data.filteredCount,
              )
            }),
            catchError((err, caught) => {
              return of(new FetchDefaultTranslationsFailure({ error: err }))
            }),
          )
      }),
    ),
  )

  UpdateTranslationsManualy$ = createEffect(() =>
    this.actions.pipe(
      ofType(i18nTypes.UPDATE_TRANSLATIONS_MANUALY),
      switchMap((action: UpdateTranslationManualy) => {
        return this.i18nService.fetchTranslations(action.iso2code).pipe(
          map((translations) => {
            this.translateService.setTranslation(action.iso2code, translations)
            this.appRef.tick()
            return new UpdateTranslationManualySuccessfully()
          }),
          catchError((err, caught) => {
            return of(new UpdateTranslationManualyFailure())
          }),
        )
      }),
    ),
  )
}
